<template>
  <div class="number-picker--wrapper">
    <div class="minus" @click="decrement"><span>-</span></div>
    <div class="input-number"><span>{{count}}</span></div>
    <div class="plus" @click="increment"><span>+</span></div>
  </div>
</template>

<style scoped>
  .number-picker--wrapper {
    border: 1px solid #c15842;
    background: #fff;
    display: inline-grid;
    grid-template-columns: 24px 1fr 24px;
    height: 26px;
    overflow: hidden;
  }
  .number-picker--wrapper {
    user-select: none;
  }
  .minus, .plus {
    background: var(--darker-orange);
    color: var(--white);
    font-weight: bold;
    text-align: center;
    line-height: 26px;
    cursor: pointer;
    transition: all 300ms ease;
  }
  .minus:hover, .plus:hover {
    background: var(--black);
  }
  .input-number {
    color: var(--black);
    text-align: center;
    line-height: 26px;
    padding: 0 20px 0 20px;
  }
</style>

<script>
  export default {
    name: "number-picker",
    props: {
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 5
      },
      updateVal: {
        type: Number
      }
    },
    watch: {
      updateVal (v) {
        this.count = v;
      }
    },
    methods: {
      decrement () {
        if (this.count - 1 < this.min) return;
        --this.count;
        this.$emit('input', this.count);
      },
      increment () {
        if (this.count + 1 > this.max) return;
        ++this.count;
        this.$emit('input', this.count);
      }
    },
    data () {
      return {
        count: 0
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/tunnel/step3/number-picker.vue